<script>
  export let data;

  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  function handleClick() {
    dispatch("close");
  }
</script>

<div class="chatwith-inline-wrapper">
  {#if data.buttonMessage && data.buttonMessage != "null" && data.buttonMessage != null}
    <div
      on:click={handleClick}
      class="chatwith-mainbutton"
      style="background:{data.color};border-radius:{data.buttonRounding}px"
    >
      <span style="color:{data.textColor}" class=" chatwith-text"
        >{data.buttonMessage}</span
      >
      <img
        class="chatwith-img"
        alt="tochat-whatsapp"
        src={data.whatsappIconUrl
          ? data.whatsappIconUrl
          : "https://widget.tochat.be/icon-1.png"}
      />
      {#if data.showCounter === true}
        <span class="no1 {data.rightpos == 0 ? 'left' : 'right'}">1</span>
      {/if}
    </div>
  {:else}
    <div
      on:click={handleClick}
      class="chatwith-mainbutton whithout-text"
      style="background:{data.color};border-radius:{data.buttonRounding}px"
    >
      <img
        class="chatwith-img"
        alt="tochat-whatsapp"
        src={data.whatsappIconUrl
          ? data.whatsappIconUrl
          : "https://widget.tochat.be/icon-1.png"}
      />
      {#if data.showCounter === true}
        <span class="no1 {data.rightpos == 0 ? 'left' : 'right'}">1</span>
      {/if}
    </div>
  {/if}
</div>

<style>
  .chatwith-mainbutton {
    position: relative;
    display: flex;
    align-items: center;
    border-radius: 200px;
    z-index: 99999;
    color: white;
    font-size: 16px;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
    min-height: 45px;
    vertical-align: middle;
    cursor: pointer;
  }
  .chatwith-mainbutton.whithout-text {
    width: 45px;
  }

  .chatwith-mainbutton .chatwith-text {
    padding: 0px 10px 0 20px;
    max-width: 225px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: block;
  }
  .chatwith-mainbutton .chatwith-img {
    height: 30px;
    width: 30px;
    display: block;
    margin-right: 5px;
    margin-left: 5px;
  }

  .chatwith-mainbutton.whithout-text .chatwith-img {
    margin: 0 auto;
  }

  .chatwith-inline-wrapper {
    display: inline-block;
  }

  .no1 {
    background: red;
    width: 15px;
    height: 15px;
    border-radius: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -3px;
    right: -3px;
    font-size: 12px;
    text-align: center;
    color: white;
  }

  .no1.left {
    right: auto;
    left: 0;
  }
</style>
